import {
  AggregateTaskParametersDc,
  AvailabilityAreaTaskDc,
  BufferTaskParametersDc,
  CopyTaskParametersDc,
  CsvStaticTaskDataStorageDc,
  ExcelStaticTaskDataStorageDc,
  FeatureTaskParametersDc,
  FilterCopyTaskParametersDc,
  InMemoryTaskDataStorageDc,
  LayerTaskDataStorageDc,
  OverlayTaskParametersDc,
  PipelineTaskParametersDc,
  StaticTaskDataStorageDc,
  TableTaskDataStorageDc,
  TilingTaskDataStorageDc,
  UnionTaskParametersDc,
} from "@evergis/api";

/** Серверные значения */
export enum SchedulerTask {
  Copy = "copy",
  FilterCopy = "filterCopy",
  Overlay = "overlay",
  Union = "union",
  Buffer = "buffer",
  Pipeline = "pipeline",
  Aggregate = "aggregate",
  AvailabilityArea = "route",
}

/** Серверные значения */
export enum TaskDataType {
  Layer = "layerTaskDataStorage",
  ConfiguredLayer = "configuredLayerStorage",
  Csv = "csvTaskDataStorage",
  Table = "tableTaskDataStorage",
  Excel = "excelTaskDataStorage",
  Static = "staticTaskDataStorage",
  Kml = "kmlTaskDataStorage",
  Gdb = "gdbTaskDataStorage",
}

type AnyTaskDataStorageDc = FeatureTaskParametersDc["source"];

export type AnyTaskParameters = PipelineTaskParameters["innerTasks"][0];

type TypeOverride<T extends { type?: string }, V> = Omit<T, "type"> & { type: V };

type TaskDataStorage<T extends { type?: string }> = TypeOverride<T, TaskDataType>;

export type LayerTaskDataStorage = TaskDataStorage<LayerTaskDataStorageDc>;
export type TableTaskDataStorage = TaskDataStorage<TableTaskDataStorageDc>;
export type StaticTaskDataStorage = TaskDataStorage<StaticTaskDataStorageDc>;
export type ExcelStaticTaskDataStorage = TaskDataStorage<ExcelStaticTaskDataStorageDc>;
export type CsvStaticTaskDataStorage = TaskDataStorage<CsvStaticTaskDataStorageDc>;
export type InMemoryTaskDataStorage = TaskDataStorage<InMemoryTaskDataStorageDc>;
export type TilingTaskDataStorage = TaskDataStorage<TilingTaskDataStorageDc>;

export type TaskDataStorageTypes =
  | LayerTaskDataStorage
  | TableTaskDataStorage
  | StaticTaskDataStorage
  | ExcelStaticTaskDataStorage
  | CsvStaticTaskDataStorage
  | InMemoryTaskDataStorage
  | TilingTaskDataStorage;

// eslint-disable-next-line @typescript-eslint/ban-types
export type SchedulerTaskPayload<Dc extends object, DataStorage = TaskDataStorageTypes> = {
  [K in keyof Dc]: Dc[K] extends AnyTaskDataStorageDc
    ? DataStorage
    : Dc[K] extends AnyTaskDataStorageDc[]
    ? DataStorage[]
    : K extends "type"
    ? SchedulerTask
    : Dc[K];
};

export type CopyTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  CopyTaskParametersDc,
  T
>;
export type OverlayTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  OverlayTaskParametersDc,
  T
>;
export type UnionTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  UnionTaskParametersDc,
  T
>;
export type AggregateTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  AggregateTaskParametersDc,
  T
>;
export type AvailabilityAreaTask<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  AvailabilityAreaTaskDc,
  T
>;
export type BufferTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  BufferTaskParametersDc,
  T
>;

export type FilterCopyTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  FilterCopyTaskParametersDc,
  T
>;

export type PipelineTaskParameters<T extends TaskDataStorageTypes = TaskDataStorageTypes> = SchedulerTaskPayload<
  PipelineTaskParametersDc,
  T
>;
